var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 66,
    viewBox: "0 0 60 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_2461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.869528 48.9687C1.17387 38.7542 11.506 35.1315 16.634 34.597C13.8134 29.7694 6.32695 20.438 12.8364 14.9908C18.8471 9.96094 29.0771 21.6599 33.112 30.2607C28.9036 19.9183 23.8052 2.16674 31.8284 0.19656C40.4163 -1.91227 45.1581 21.5636 46.4556 33.5651C46.7331 26.2807 49.2573 13.5874 57.1336 21.09C65.0098 28.5926 53.9303 37.3731 47.406 40.8256C52.7565 40.9457 68.2014 58.6169 54.2539 55.5194C40.3064 52.422 30.4258 2.02127 35.9997 32.0619C41.5736 62.1026 27.4907 70.5104 18.9613 61.7804C15.5962 58.3362 16.6422 51.5045 18.9759 45.1462C11.033 52.485 0.619586 57.3574 0.869528 48.9687Z",
    fill: "#64A2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_2461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPattern);
export default __webpack_public_path__ + "static/media/about-pattern.434cd542f2a4ba7b5cc0542787c1dd78.svg";
export { ForwardRef as ReactComponent };